import { render, staticRenderFns } from "./orderPop.vue?vue&type=template&id=6181720d&scoped=true"
import script from "./orderPop.vue?vue&type=script&lang=js"
export * from "./orderPop.vue?vue&type=script&lang=js"
import style0 from "./orderPop.vue?vue&type=style&index=0&id=6181720d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181720d",
  null
  
)

export default component.exports